import { render, staticRenderFns } from "./pieVehiculos.vue?vue&type=template&id=48d825c6"
import script from "./pieVehiculos.vue?vue&type=script&lang=js"
export * from "./pieVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports